import { createAction, props } from '@ngrx/store';
import { clientLandRoleEntity } from './land-role.models';

export const loadLandRole = createAction('[Land Role] Load Land & Role', props<{ language: string }>());

export const loadLandRoleSuccess = createAction(
  '[Land Role] Load Land & Role Success',
  props<{ landRole: clientLandRoleEntity }>()
);

export const loadLandRoleFailure = createAction('[Land Role] Load Land & Role Failure', props<{ error: any }>());

export const clearLandRole = createAction('[Land Role] Clear Land Role');
